module.exports = __webpack_public_path__ + "img/letters_n.276c1776.png";